export const DEFAULT_PAGE_SIZE = 10;

export const newsPaginationParams = {
  page: 0,
  size: DEFAULT_PAGE_SIZE,
  // sort: 'id',
};
